import React, { useState, useEffect, useContext } from "react";
import { validate } from './Validate';
import useForm from '../banner/customHooks';
import { X_TENANT_ID, THEME_URL, UPLOADIMAGE } from '../../common/ActionUrl'
import axios from 'axios';
import { AuthContext } from "../../common/Auth"
import CategorySectionForm from './CategorySectionForm';
import { _useToasts } from "../../common/_useToasts";
import { USERTYPES } from "../../constant/userType";

const Category = ({ editType, handleClose, fromEditAction }) => {
	const { user, userType, getThemeSettings } = useContext(AuthContext)

	const { inputs, handleInputChange, handleSubmit, resetColor,
		handleColorPicker, handleCheckboxInputChange, errors } = useForm({
			firstCatMainText: "", firstCatMainTextColor: "", firstCatMainTextFont: "", firstCatMainTextFontSize: "", firstCatText: "", firstCatTextColor: "", firstCatTextFont: "", firstCatTextFontSize: "", firstCatPriceText: "", firstCatPriceTextColor: "", firstCatPriceTextFont: "", firstCatPriceTextFontSize: "", firstCatImage: "", firstCatLink: "",
			secondCatMainText: "", secondCatMainTextColor: "", secondCatMainTextFont: "", secondCatMainTextFontSize: "", secondCatText: "", secondCatTextColor: "", secondCatTextFont: "", secondCatTextFontSize: "", secondCatPriceText: "", secondCatPriceTextColor: "", secondCatPriceTextFont: "", secondCatPriceTextFontSize: "", secondCatImage: "", secondCatLink: "",
			thirdCatMainText: "", thirdCatMainTextColor: "", thirdCatMainTextFont: "", thirdCatMainTextFontSize: "", thirdCatText: "", thirdCatTextColor: "", thirdCatTextFont: "", thirdCatTextFontSize: "", thirdCatPriceText: "", thirdCatPriceTextColor: "", thirdCatPriceTextFont: "", thirdCatPriceTextFontSize: "", thirdCatImage: "", thirdCatLink: "",
			fourthCatMainText: "", fourthCatMainTextColor: "", fourthCatMainTextFont: "", fourthCatMainTextFontSize: "", fourthCatText: "", fourthCatTextColor: "", fourthCatTextFont: "", fourthCatTextFontSize: "", fourthCatPriceText: "", fourthCatPriceTextColor: "", fourthCatPriceTextFont: "", fourthCatPriceTextFontSize: "", fourthCatImage: "", fourthCatLink: "",
			fifthCatMainText: "", fifthCatMainTextColor: "", fifthCatMainTextFont: "", fifthCatMainTextFontSize: "", fifthCatText: "", fifthCatTextColor: "", fifthCatTextFont: "", fifthCatTextFontSize: "", fifthCatPriceText: "", fifthCatPriceTextColor: "", fifthCatPriceTextFont: "", fifthCatPriceTextFontSize: "", fifthCatImage: "", fifthCatLink: "",
			sixthCatMainText: "", sixthCatMainTextColor: "", sixthCatMainTextFont: "", sixthCatMainTextFontSize: "", sixthCatText: "", sixthCatTextColor: "", sixthCatTextFont: "", sixthCatTextFontSize: "", sixthCatPriceText: "", sixthCatPriceTextColor: "", sixthCatPriceTextFont: "", sixthCatPriceTextFontSize: "", sixthCatImage: "", sixthCatLink: "",

			seventhCatMainText: "", seventhCatMainTextColor: "", seventhCatMainTextFont: "", seventhCatMainTextFontSize: "", seventhCatText: "", seventhCatTextColor: "", seventhCatTextFont: "", seventhCatTextFontSize: "", seventhCatPriceText: "", seventhCatPriceTextColor: "", seventhCatPriceTextFont: "", seventhCatPriceTextFontSize: "", seventhCatImage: "", seventhCatLink: "",

			eightCatMainText: "", eightCatMainTextColor: "", eightCatMainTextFont: "", eightCatMainTextFontSize: "", eightCatText: "", eightCatTextColor: "", eightCatTextFont: "", eightCatTextFontSize: "", eightCatPriceText: "", eightCatPriceTextColor: "", eightCatPriceTextFont: "", eightCatPriceTextFontSize: "", eightCatImage: "", eightCatLink: "",

			nineCatMainText: "", nineCatMainTextColor: "", nineCatMainTextFont: "", nineCatMainTextFontSize: "", nineCatText: "", nineCatTextColor: "", nineCatTextFont: "", nineCatTextFontSize: "", nineCatPriceText: "", nineCatPriceTextColor: "", nineCatPriceTextFont: "", nineCatPriceTextFontSize: "", nineCatImage: "", nineCatLink: "",

			imageBoxSize: "", spaceBetweenBox: "",
			linkIcon: "",showIcon:"",
			iconColor: "",iconHoverColor : "",

			paddingTop: "", paddingBottom: "", marginTop: "", marginBottom: "", marginRight: "", marginLeft: "", paddingRight: "", paddingLeft: "", fullSection: false
		},
			validate, updateDealCallback);

	const { _addToast } = _useToasts();
	const [catData, setCatData] = useState({})
	const [isLoading, setIsLoading] = useState(false)
	const [toggle, setToggle] = useState(false)
	const [tempImage, setTempImage] = useState("");
	const [tempBgImage, setTempBgImage] = useState("");
	const [catSectionID, setCatSectionID] = useState(null);
	const userId = user?.userId
	async function updateDealCallback() {

		let insertData = {
			"values": {
				"firstCatText": inputs.firstCatText,
				"firstCatTextColor": inputs.firstCatTextColor,
				"firstCatTextFont": inputs.firstCatTextFont,
				"firstCatTextFontSize": inputs.firstCatTextFontSize,
				"firstCatMainText": inputs.firstCatMainText,
				"firstCatMainTextColor": inputs.firstCatMainTextColor,
				"firstCatMainTextFont": inputs.firstCatMainTextFont,
				"firstCatMainTextFontSize": inputs.firstCatMainTextFontSize,
				"firstCatPriceText": inputs.firstCatPriceText,
				"firstCatPriceTextColor": inputs.firstCatPriceTextColor,
				"firstCatPriceTextFont": inputs.firstCatPriceTextFont,
				"firstCatPriceTextFontSize": inputs.firstCatPriceTextFontSize,
				"firstCatImage": inputs.firstCatImage,
				"firstCatLink": inputs.firstCatLink,

				"secondCatText": inputs.secondCatText,
				"secondCatTextColor": inputs.secondCatTextColor,
				"secondCatTextFont": inputs.secondCatTextFont,
				"secondCatTextFontSize": inputs.secondCatTextFontSize,
				"secondCatMainText": inputs.secondCatMainText,
				"secondCatMainTextColor": inputs.secondCatMainTextColor,
				"secondCatMainTextFont": inputs.secondCatMainTextFont,
				"secondCatMainTextFontSize": inputs.secondCatMainTextFontSize,
				"secondCatPriceText": inputs.secondCatPriceText,
				"secondCatPriceTextColor": inputs.secondCatPriceTextColor,
				"secondCatPriceTextFont": inputs.secondCatPriceTextFont,
				"secondCatPriceTextFontSize": inputs.secondCatPriceTextFontSize,
				"secondCatImage": inputs.secondCatImage,
				"secondCatLink": inputs.secondCatLink,

				"thirdCatText": inputs.thirdCatText,
				"thirdCatTextFont": inputs.thirdCatTextFont,
				"thirdCatTextFontSize": inputs.thirdCatTextFontSize,
				"thirdCatTextColor": inputs.thirdCatTextColor,
				"thirdCatMainText": inputs.thirdCatMainText,
				"thirdCatMainTextColor": inputs.thirdCatMainTextColor,
				"thirdCatMainTextFont": inputs.thirdCatMainTextFont,
				"thirdCatMainTextFontSize": inputs.thirdCatMainTextFontSize,
				"thirdCatPriceText": inputs.thirdCatPriceText,
				"thirdCatPriceTextColor": inputs.thirdCatPriceTextColor,
				"thirdCatPriceTextFont": inputs.thirdCatPriceTextFont,
				"thirdCatPriceTextFontSize": inputs.thirdCatPriceTextFontSize,
				"thirdCatImage": inputs.thirdCatImage,
				"thirdCatLink": inputs.thirdCatLink,

				"fourthCatText": inputs.fourthCatText,
				"fourthCatTextFont": inputs.fourthCatTextFont,
				"fourthCatTextFontSize": inputs.fourthCatTextFontSize,
				"fourthCatTextColor": inputs.fourthCatTextColor,
				"fourthCatMainText": inputs.fourthCatMainText,
				"fourthCatMainTextColor": inputs.fourthCatMainTextColor,
				"fourthCatMainTextFont": inputs.fourthCatMainTextFont,
				"fourthCatMainTextFontSize": inputs.fourthCatMainTextFontSize,
				"fourthCatPriceText": inputs.fourthCatPriceText,
				"fourthCatPriceTextColor": inputs.fourthCatPriceTextColor,
				"fourthCatPriceTextFont": inputs.fourthCatPriceTextFont,
				"fourthCatPriceTextFontSize": inputs.fourthCatPriceTextFontSize,
				"fourthCatImage": inputs.fourthCatImage,
				"fourthCatLink": inputs.fourthCatLink,

				"fifthCatText": inputs.fifthCatText,
				"fifthCatTextColor": inputs.fifthCatTextColor,
				"fifthCatTextFont": inputs.fifthCatTextFont,
				"fifthCatTextFontSize": inputs.fifthCatTextFontSize,
				"fifthCatMainText": inputs.fifthCatMainText,
				"fifthCatMainTextColor": inputs.fifthCatMainTextColor,
				"fifthCatMainTextFont": inputs.fifthCatMainTextFont,
				"fifthCatMainTextFontSize": inputs.fifthCatMainTextFontSize,
				"fifthCatPriceText": inputs.fifthCatPriceText,
				"fifthCatPriceTextColor": inputs.fifthCatPriceTextColor,
				"fifthCatPriceTextFont": inputs.fifthCatPriceTextFont,
				"fifthCatPriceTextFontSize": inputs.fifthCatPriceTextFontSize,
				"fifthCatImage": inputs.fifthCatImage,
				"fifthCatLink": inputs.fifthCatLink,

				"sixthCatMainText": inputs.sixthCatMainText,
				"sixthCatMainTextColor": inputs.sixthCatMainTextColor,
				"sixthCatMainTextFont": inputs.sixthCatMainTextFont,
				"sixthCatMainTextFontSize": inputs.sixthCatMainTextFontSize,
				"sixthCatText": inputs.sixthCatText,
				"sixthCatTextColor": inputs.sixthCatTextColor,
				"sixthCatTextFont": inputs.sixthCatTextFont,
				"sixthCatTextFontSize": inputs.sixthCatTextFontSize,
				"sixthCatPriceText": inputs.sixthCatPriceText,
				"sixthCatPriceTextColor": inputs.sixthCatPriceTextColor,
				"sixthCatPriceTextFont": inputs.sixthCatPriceTextFont,
				"sixthCatPriceTextFontSize": inputs.sixthCatPriceTextFontSize,
				"sixthCatImage": inputs.sixthCatImage,
				"sixthCatLink": inputs.sixthCatLink,

				"seventhCatMainTextColor": inputs.seventhCatMainTextColor,
				"seventhCatMainText": inputs.seventhCatMainText,
				"seventhCatMainTextFont": inputs.seventhCatMainTextFont,
				"seventhCatMainTextFontSize": inputs.seventhCatMainTextFontSize,
				"seventhCatText": inputs.seventhCatText,
				"seventhCatTextColor": inputs.seventhCatTextColor,
				"seventhCatTextFont": inputs.seventhCatTextFont,
				"seventhCatTextFontSize": inputs.seventhCatTextFontSize,
				"seventhCatPriceText": inputs.seventhCatPriceText,
				"seventhCatPriceTextColor": inputs.seventhCatPriceTextColor,
				"seventhCatPriceTextFont": inputs.seventhCatPriceTextFont,
				"seventhCatPriceTextFontSize": inputs.seventhCatPriceTextFontSize,
				"seventhCatImage": inputs.seventhCatImage,
				"seventhCatLink": inputs.seventhCatLink,

				"eightCatMainTextColor": inputs.eightCatMainTextColor,
				"eightCatMainText": inputs.eightCatMainText,
				"eightCatMainTextFont": inputs.eightCatMainTextFont,
				"eightCatMainTextFontSize": inputs.eightCatMainTextFontSize,
				"eightCatText": inputs.eightCatText,
				"eightCatTextColor": inputs.eightCatTextColor,
				"eightCatTextFont": inputs.eightCatTextFont,
				"eightCatTextFontSize": inputs.eightCatTextFontSize,
				"eightCatPriceText": inputs.eightCatPriceText,
				"eightCatPriceTextColor": inputs.eightCatPriceTextColor,
				"eightCatPriceTextFont": inputs.eightCatPriceTextFont,
				"eightCatPriceTextFontSize": inputs.eightCatPriceTextFontSize,
				"eightCatImage": inputs.eightCatImage,
				"eightCatLink": inputs.eightCatLink,

				"nineCatMainTextColor": inputs.nineCatMainTextColor,
				"nineCatMainText": inputs.nineCatMainText,
				"nineCatMainTextFont": inputs.nineCatMainTextFont,
				"nineCatMainTextFontSize": inputs.nineCatMainTextFontSize,
				"nineCatText": inputs.nineCatText,
				"nineCatTextColor": inputs.nineCatTextColor,
				"nineCatTextFont": inputs.nineCatTextFont,
				"nineCatTextFontSize": inputs.nineCatTextFontSize,
				"nineCatPriceText": inputs.nineCatPriceText,
				"nineCatPriceTextColor": inputs.nineCatPriceTextColor,
				"nineCatPriceTextFont": inputs.nineCatPriceTextFont,
				"nineCatPriceTextFontSize": inputs.nineCatPriceTextFontSize,
				"nineCatImage": inputs.nineCatImage,
				"nineCatLink": inputs.nineCatLink,

				"imageBoxSize": inputs.imageBoxSize,
				"spaceBetweenBox": inputs.spaceBetweenBox,
				"linkIcon": inputs.linkIcon,
				"showIcon" : inputs.showIcon,
				"iconColor": inputs.iconColor,
				"iconHoverColor" : inputs.iconHoverColor,
				"paddingTop": inputs.paddingTop,
				"paddingBottom": inputs.paddingBottom,
				"marginTop": inputs.marginTop,
				"marginBottom": inputs.marginBottom,
				"marginRight": inputs.marginRight,
				"marginLeft": inputs.marginLeft,
				"paddingRight": inputs.paddingRight,
				"paddingLeft": inputs.paddingLeft,
				"fullSection": inputs.fullSection
			},
			"settingsName": "categorySection",
			userId
		}

		const requestOptions = {
			headers: { 'Content-Type': 'application/json', 'X-TENANT-ID': X_TENANT_ID }
		};
		setIsLoading(true)
		if (catSectionID) {
			axios.patch(THEME_URL + catSectionID, insertData, requestOptions)
				.then(res => {
					setIsLoading(false)
					if (res.data.error) {
						_addToast(res.data.message, {
							appearance: "error",
							autoDismiss: true
						});
					} else {
						getThemeSettings()
						handleClose()
					}
				}).catch(err => {
					console.log('err', err);
				});
		} else {
			axios.post(THEME_URL, insertData, requestOptions)
				.then(res => {
					setIsLoading(false)
					if (res.data.error) {
						_addToast(res.data.message, {
							appearance: "error",
							autoDismiss: true
						});
					} else {
						getThemeSettings()
						handleClose()
					}
				})
				.catch((error, config, code, request, response) => {
					setIsLoading(false)
					_addToast('Issues while create user', {
						appearance: "error",
						autoDismiss: true
					});

				});
		}

	}
	const getCategorySectionData = () => {
		setIsLoading(true)
		const requestOptions = {
			headers: { 'Content-Type': 'application/json', 'X-TENANT-ID': X_TENANT_ID }
		};
		axios.get(THEME_URL, requestOptions)
			.then(res => {
				setIsLoading(false)
				if (res.data.error) {
					_addToast(res.data.message, {
						appearance: "error",
						autoDismiss: true
					});
				} else {
					res.data.map((items, index) => {
						if (items.settingsName === "categorySection") {
							setCatData(items.values[0])
							setCatSectionID(items._id)
						}
					})
				}
			})
			.catch(err => {
				console.log('err', err);
			});
	}

	useEffect(() => {

		getCategorySectionData()

	}, [])

	//its a temp value for update inputs value when edit data
	const [value, setValue] = useState(0);
	useEffect(() => {
		if (Object.keys(catData).length > 0) {
			inputs.firstCatText = catData.firstCatText
			inputs.firstCatTextFont = catData.firstCatTextFont
			inputs.firstCatTextFontSize = catData.firstCatTextFontSize
			inputs.firstCatTextColor = catData.firstCatTextColor
			inputs.firstCatMainText = catData.firstCatMainText
			inputs.firstCatMainTextColor = catData.firstCatMainTextColor
			inputs.firstCatMainTextFont = catData.firstCatMainTextFont
			inputs.firstCatMainTextFontSize = catData.firstCatMainTextFontSize
			inputs.firstCatPriceText = catData.firstCatPriceText
			inputs.firstCatPriceTextColor = catData.firstCatPriceTextColor
			inputs.firstCatPriceTextFont = catData.firstCatPriceTextFont
			inputs.firstCatPriceTextFontSize = catData.firstCatPriceTextFontSize
			inputs.firstCatImage = catData.firstCatImage
			inputs.firstCatLink = catData.firstCatLink

			inputs.secondCatText = catData.secondCatText
			inputs.secondCatTextFont = catData.secondCatTextFont
			inputs.secondCatTextFontSize = catData.secondCatTextFontSize
			inputs.secondCatTextColor = catData.secondCatTextColor
			inputs.secondCatMainText = catData.secondCatMainText
			inputs.secondCatMainTextColor = catData.secondCatMainTextColor
			inputs.secondCatMainTextFont = catData.secondCatMainTextFont
			inputs.secondCatMainTextFontSize = catData.secondCatMainTextFontSize
			inputs.secondCatPriceText = catData.secondCatPriceText
			inputs.secondCatPriceTextColor = catData.secondCatPriceTextColor
			inputs.secondCatPriceTextFont = catData.secondCatPriceTextFont
			inputs.secondCatPriceTextFontSize = catData.secondCatPriceTextFontSize
			inputs.secondCatImage = catData.secondCatImage
			inputs.secondCatLink = catData.secondCatLink

			inputs.thirdCatText = catData.thirdCatText
			inputs.thirdCatTextFont = catData.thirdCatTextFont
			inputs.thirdCatTextFontSize = catData.thirdCatTextFontSize
			inputs.thirdCatTextColor = catData.thirdCatTextColor
			inputs.thirdCatMainText = catData.thirdCatMainText
			inputs.thirdCatMainTextColor = catData.thirdCatMainTextColor
			inputs.thirdCatMainTextFont = catData.thirdCatMainTextFont
			inputs.thirdCatMainTextFontSize = catData.thirdCatMainTextFontSize
			inputs.thirdCatPriceText = catData.thirdCatPriceText
			inputs.thirdCatPriceTextColor = catData.thirdCatPriceTextColor
			inputs.thirdCatPriceTextFont = catData.thirdCatPriceTextFont
			inputs.thirdCatPriceTextFontSize = catData.thirdCatPriceTextFontSize
			inputs.thirdCatImage = catData.thirdCatImage
			inputs.thirdCatLink = catData.thirdCatLink

			inputs.fourthCatText = catData.fourthCatText
			inputs.fourthCatTextColor = catData.fourthCatTextColor
			inputs.fourthCatTextFont = catData.fourthCatTextFont
			inputs.fourthCatTextFontSize = catData.fourthCatTextFontSize
			inputs.fourthCatMainText = catData.fourthCatMainText
			inputs.fourthCatMainTextColor = catData.fourthCatMainTextColor
			inputs.fourthCatMainTextFont = catData.fourthCatMainTextFont
			inputs.fourthCatMainTextFontSize = catData.fourthCatMainTextFontSize
			inputs.fourthCatPriceText = catData.fourthCatPriceText
			inputs.fourthCatPriceTextColor = catData.fourthCatPriceTextColor
			inputs.fourthCatPriceTextFont = catData.fourthCatPriceTextFont
			inputs.fourthCatPriceTextFontSize = catData.fourthCatPriceTextFontSize
			inputs.fourthCatImage = catData.fourthCatImage
			inputs.fourthCatLink = catData.fourthCatLink

			inputs.fifthCatText = catData.fifthCatText
			inputs.fifthCatTextFont = catData.fifthCatTextFont
			inputs.fifthCatTextFontSize = catData.fifthCatTextFontSize
			inputs.fifthCatTextColor = catData.fifthCatTextColor
			inputs.fifthCatMainText = catData.fifthCatMainText
			inputs.fifthCatMainTextColor = catData.fifthCatMainTextColor
			inputs.fifthCatMainTextFont = catData.fifthCatMainTextFont
			inputs.fifthCatMainTextFontSize = catData.fifthCatMainTextFontSize
			inputs.fifthCatPriceText = catData.fifthCatPriceText
			inputs.fifthCatPriceTextColor = catData.fifthCatPriceTextColor
			inputs.fifthCatPriceTextFont = catData.fifthCatPriceTextFont
			inputs.fifthCatPriceTextFontSize = catData.fifthCatPriceTextFontSize
			inputs.fifthCatImage = catData.fifthCatImage
			inputs.fifthCatLink = catData.fifthCatLink

			inputs.sixthCatText = catData.sixthCatText
			inputs.sixthCatTextFont = catData.sixthCatTextFont
			inputs.sixthCatTextFontSize = catData.sixthCatTextFontSize
			inputs.sixthCatTextColor = catData.sixthCatTextColor
			inputs.sixthCatMainText = catData.sixthCatMainText
			inputs.sixthCatMainTextColor = catData.sixthCatMainTextColor
			inputs.sixthCatMainTextFont = catData.sixthCatMainTextFont
			inputs.sixthCatMainTextFontSize = catData.sixthCatMainTextFontSize
			inputs.sixthCatPriceText = catData.sixthCatPriceText
			inputs.sixthCatPriceTextColor = catData.sixthCatPriceTextColor
			inputs.sixthCatPriceTextFont = catData.sixthCatPriceTextFont
			inputs.sixthCatPriceTextFontSize = catData.sixthCatPriceTextFontSize
			inputs.sixthCatImage = catData.sixthCatImage
			inputs.sixthCatLink = catData.sixthCatLink

			inputs.seventhCatText = catData.seventhCatText
			inputs.seventhCatTextFont = catData.seventhCatTextFont
			inputs.seventhCatTextFontSize = catData.seventhCatTextFontSize
			inputs.seventhCatTextColor = catData.seventhCatTextColor
			inputs.seventhCatMainText = catData.seventhCatMainText
			inputs.seventhCatMainTextColor = catData.seventhCatMainTextColor
			inputs.seventhCatMainTextFont = catData.seventhCatMainTextFont
			inputs.seventhCatMainTextFontSize = catData.seventhCatMainTextFontSize
			inputs.seventhCatPriceText = catData.seventhCatPriceText
			inputs.seventhCatPriceTextColor = catData.seventhCatPriceTextColor
			inputs.seventhCatPriceTextFont = catData.seventhCatPriceTextFont
			inputs.seventhCatPriceTextFontSize = catData.seventhCatPriceTextFontSize
			inputs.seventhCatImage = catData.seventhCatImage
			inputs.seventhCatLink = catData.seventhCatLink

			inputs.eightCatText = catData.eightCatText
			inputs.eightCatTextFont = catData.eightCatTextFont
			inputs.eightCatTextFontSize = catData.eightCatTextFontSize
			inputs.eightCatTextColor = catData.eightCatTextColor
			inputs.eightCatMainText = catData.eightCatMainText
			inputs.eightCatMainTextColor = catData.eightCatMainTextColor
			inputs.eightCatMainTextFont = catData.eightCatMainTextFont
			inputs.eightCatMainTextFontSize = catData.eightCatMainTextFontSize
			inputs.eightCatPriceText = catData.eightCatPriceText
			inputs.eightCatPriceTextColor = catData.eightCatPriceTextColor
			inputs.eightCatPriceTextFont = catData.eightCatPriceTextFont
			inputs.eightCatPriceTextFontSize = catData.eightCatPriceTextFontSize
			inputs.eightCatImage = catData.eightCatImage
			inputs.eightCatLink = catData.eightCatLink

			inputs.nineCatText = catData.nineCatText
			inputs.nineCatTextFont = catData.nineCatTextFont
			inputs.nineCatTextFontSize = catData.nineCatTextFontSize
			inputs.nineCatTextColor = catData.nineCatTextColor
			inputs.nineCatMainText = catData.nineCatMainText
			inputs.nineCatMainTextColor = catData.nineCatMainTextColor
			inputs.nineCatMainTextFont = catData.nineCatMainTextFont
			inputs.nineCatMainTextFontSize = catData.nineCatMainTextFontSize
			inputs.nineCatPriceText = catData.nineCatPriceText
			inputs.nineCatPriceTextColor = catData.nineCatPriceTextColor
			inputs.nineCatPriceTextFont = catData.nineCatPriceTextFont
			inputs.nineCatPriceTextFontSize = catData.nineCatPriceTextFontSize
			inputs.nineCatImage = catData.nineCatImage
			inputs.nineCatLink = catData.nineCatLink

			inputs.imageBoxSize = catData.imageBoxSize
			inputs.spaceBetweenBox = catData.spaceBetweenBox
			inputs.linkIcon = catData.linkIcon
			inputs.showIcon = catData.showIcon
			inputs.iconColor = catData.iconColor
			inputs.iconHoverColor = catData.iconHoverColor
			inputs.paddingTop = catData.paddingTop
			inputs.paddingBottom = catData.paddingBottom
			inputs.marginTop = catData.marginTop
			inputs.marginBottom = catData.marginBottom
			inputs.marginRight = catData.marginRight
			inputs.marginLeft = catData.marginLeft
			inputs.paddingRight = catData.paddingRight
			inputs.paddingLeft = catData.paddingLeft
			inputs.fullSection = catData.fullSection
			setValue(value => value + 1);
		}
	}, [catData])

	const setImageFile = (event, type) => {
		const photoTarget = event.target.files[0];
		if (photoTarget.name.match(/\.(jpg|jpeg|png|gif|webp)$/)) {
			setIsLoading(true)
			const formData = new FormData();
			formData.append("file", photoTarget, photoTarget.name);

			const requestOptions = {
				headers: { 'Content-Type': 'application/json', 'X-TENANT-ID': X_TENANT_ID }
			};
			axios.post(UPLOADIMAGE, formData, requestOptions)
				.then(res => {
					setIsLoading(false)
					if (res.data.error) {

						_addToast(res.data.message, {
							appearance: "error",
							autoDismiss: true
						});

					} else {
						if (res.data && res.data.Location != "") {
							inputs[type] = res.data.Location
							setToggle(!toggle)
						}
					}
				}).catch((error, config, code, request, response) => {
					setIsLoading(false)
					_addToast('Error while Uploded Image!', {
						appearance: "error",
						autoDismiss: true
					});

				});
		} else {
			setIsLoading(false)
			_addToast('Image type not allow', {
				appearance: "error",
				autoDismiss: true
			});
		}
	}
	const convertToSlug = (Text) => {
		return Text.toString().normalize('NFD').replace(/[\u0300-\u036f]/g, "") //remove diacritics
			.toLowerCase()
			.replace(/\s+/g, '-') //spaces to dashes
			.replace(/&/g, '-and-') //ampersand to and
			.replace(/[^\w\-]+/g, '') //remove non-words
			.replace(/\-\-+/g, '-') //collapse multiple dashes
			.replace(/^-+/, '') //trim starting dash
			.replace(/-+$/, ''); //trim ending dash
	}
	const deleteImage = (type) => {
		inputs[type] = ""
		setToggle(!toggle)
	}
	const handleInputChangeUrl = (e, key) => {
		if (e.target.value != "") {
			inputs[key] = (e.target.value)
			setToggle(!toggle)
		}
	}
	return (
		<>
			<div className="contact-area pt-10 pb-10">
				{userType !== USERTYPES.USER ?
					<>
						<CategorySectionForm
							handleCheckboxInputChange={handleCheckboxInputChange}
							isLoading={isLoading}
							handleInputChangeUrl={handleInputChangeUrl}
							inputs={inputs}
							handleSubmit={handleSubmit}
							handleInputChange={handleInputChange} errors={errors}
							handleColorPicker={handleColorPicker}
							editType={editType}
							handleClose={handleClose}
							fromEditAction={fromEditAction}
							setToggle={setToggle}
							toggle={toggle}
							resetColor={resetColor}
							setImageFile={setImageFile}
							deleteImage={deleteImage}
							tempImage={tempImage}
							tempBgImage={tempBgImage}
						/>
					</> : <h2>You haven't authority for update settings</h2>}
			</div>
		</>
	);
};

export default Category;
